<script>
import CommonTableComponent from "@/components/table.vue";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  name: "notificationExpirations",
  mixins: [pagination, tableSearch],
  components: {
    CommonTableComponent,
  },
  data() {
    return {
      filters: {
        page: 1,
        column: this.$route.query.column || "expiration_date",
        dir: this.$route.query.dir || "DESC",
        zz_legal_document_type_id: this.$route.query.zz_legal_document_type_id || "zz_legal_document_type_id"
      },
      data_permit: [],
      data_contract: [],
      data_prior: [],
      busyGetData: false,
      notifications: [],
      //isExpanded: false,
      isExpandedPermit: false,
      isExpandedContract: false,
      isExpandedPrior: false,
      transportContract: { transport_ni_id: {} },
      treatmentContract: { treatment_ni_id: {} },
    };
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.top_notification_expirations, {
        ...this.filters,
      });
      const {status, data} = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.notifications = this.$_.isEmpty(result.data) ? [] : result.data;
        const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        //meta.total = this.notifications.length // 表示内容を distinct する前の件数が入っているので、件数を実データに合わせて上書き
        //this.setMeta(meta);
        this.data_permit = this.notifications.filter(item => item.zz_legal_document_type_id === "01"); 
        this.data_contract = this.notifications.filter(item => item.zz_legal_document_type_id === '11' || item.zz_legal_document_type_id === '12'); 
        this.data_prior = this.notifications.filter(item => item.zz_legal_document_type_id === "21"); 
        this.setMeta({
          totalPermit: this.data_permit.length,
          totalContract: this.data_contract.length,
          totalPrior: this.data_prior.length,
        });
      }
    },
    updateUrlFilters() {
      this.getData()
    },
    //toggleItem() {
    //  this.isExpanded = !this.isExpanded;
    //}
    togglePermit() {
    },
    toggleContract() {
    },
    togglePrior() {
    },
    displayLinkContract(){
      return this.transportContract?.transport_contract_id != null || this.treatmentContract?.treatment_contract_id != null;
    },
    toNIContract(transport_contract_id, treatment_contract_id){
      if (transport_contract_id != null) {
        return this.$constant.ni_transport_contract_uri + transport_contract_id;
      }
      if (treatment_contract_id != null) {
        return this.$constant.ni_treatment_contract_uri + treatment_contract_id;
      }
      return "";
    }
  },
  watch: {
    'filters.page': {
      immediate: false,
      handler() {
        this.getData();
      },
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "有効期限",
          value: "expiration_date",
          sortable: true,
          width: 10
        },
        {
          text: "種類",
          value: "zz_legal_document",
          sortable: true,
          width: 10
        },
        {
          text: "内容",
          value: "content",
          sortable: true,
          width: 80
        },
      ];
    },
  },
};
</script>

<template>
  <div class="row">
    <b-overlay
      :show="busyGetData"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block"
    >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div
              @click="togglePermit()"
              v-b-toggle.collapse-notification-expirations_permit
              class="card-title mb-2 mt-2">
              <span class="font-size-16">許可証（{{ meta.totalPermit }}件）</span>
              <span :class="{'rotate': isExpandedPermit}" class="icon">▼</span>
            </div>
            <b-collapse id="collapse-notification-expirations_permit" v-model="isExpandedPermit">
              <CommonTableComponent :scrollAble="data_permit.length >= this.$constant.scroll_able_records">
                <thead class="table-light">
                <tr>
                  <th
                    :style="`width: ${item.width}`"
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                    <span v-if="item.sortable" @click="clickSort(item.value)">
                      {{ item.text }}
                      <i :class="getSortClass(item.value)"></i>
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in data_permit" :key="index">
                  <td>
                    {{ item.expiration_date }}
                  </td>
                  <td>
                    {{ item.legal_document_type_name }}
                  </td>
                  <td>
                    {{ item.content_by_legal_document }}
                  </td>
                </tr>
                <tr v-if="!data_permit.length && !busyGetData">
                  <td colspan="7" class="text-center">
                    有効期限間近の許可証はありません
                  </td>
                </tr>
                </tbody>
              </CommonTableComponent>
            </b-collapse>
          </div>
        </div>
      </div>
      
      <div class="col-lg-12">
        <div class="card">
           <div class="card-body">
            <div
              @click="toggleContract()"
              v-b-toggle.collapse-notification-expirations_contract
              class="card-title mb-2 mt-2">
              <span class="font-size-16">契約書（{{ meta.totalContract }}件）</span>
              <span :class="{'rotate': isExpandedContract}" class="icon">▼</span>
            </div>
            <b-collapse id="collapse-notification-expirations_contract" v-model="isExpandedContract">
              <CommonTableComponent :scrollAble="data_contract.length >= this.$constant.scroll_able_records">
                <thead class="table-light">
                <tr>
                  <th
                    :style="`width: ${item.width}`"
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                    <span v-if="item.sortable" @click="clickSort(item.value)">
                      {{ item.text }}
                      <i :class="getSortClass(item.value)"></i>
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in data_contract" :key="index">
                  <td>
                    {{ item.expiration_date }}
                  </td>
                  <td>
                    {{ item.legal_document_type_name }}
                  </td>
                  <td>
                    <a :href="toNIContract(item.transport_ni_id ,item.treatment_ni_id)" target="_blank">{{ item.content_by_legal_document }}</a>
                  </td>
                </tr>
                <tr v-if="!data_contract.length && !busyGetData">
                  <td colspan="7" class="text-center">
                    有効期限間近の契約書はありません
                  </td>
                </tr>
                </tbody>
              </CommonTableComponent>
            <b-row v-if="displayLinkContract()">
              <div class="content-block mb-3">
                <a target="_blank" :href="toNIContract()">
                  {{ item.content_by_legal_document  }}
                </a>
                <i class="fas fa-clone"></i>
               </div>
            </b-row>
            </b-collapse>
          </div>
        </div>
      </div>
      
      <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
            <div
              @click="togglePrior()"
              v-b-toggle.collapse-notification-expirations_prior
              class="card-title mb-2 mt-2">
              <span class="font-size-16">事前協議書（{{ meta.totalPrior }}件）</span>
              <span :class="{'rotate': isExpandedPrior}" class="icon">▼</span>
            </div>
            <b-collapse id="collapse-notification-expirations_prior" v-model="isExpandedPrior">
              <CommonTableComponent :scrollAble="data_prior.length >= this.$constant.scroll_able_records">
                <thead class="table-light">
                <tr>
                  <th
                    :style="`width: ${item.width}`"
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                    <span v-if="item.sortable" @click="clickSort(item.value)">
                      {{ item.text }}
                      <i :class="getSortClass(item.value)"></i>
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in data_prior" :key="index">
                  <td>
                    {{ item.expiration_date }}
                  </td>
                  <td>
                    {{ item.legal_document_type_name }}
                  </td>
                  <td>
                    <a :href="toNIContract(item.transport_ni_id ,item.treatment_ni_id)" target="_blank">{{ item.content_by_legal_document }}</a>
                  </td>
                </tr>
                <tr v-if="!data_prior.length && !busyGetData">
                  <td colspan="7" class="text-center">
                    有効期限間近の事前協議書はありません
                  </td>
                </tr>
                </tbody>
              </CommonTableComponent>
            <b-row v-if="displayLinkContract()">
              <div class="content-block mb-3">
                <a target="_blank" :href="toNIContract()">
                  {{ item.content_by_legal_document  }}
                </a>
                <i class="fas fa-clone"></i>
               </div>
            </b-row>
            </b-collapse>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
  <!-- end row -->
</template>
<style scoped>
.icon {
  float: right;
  transition: transform 0.3s;
}

.rotate {
  transform: rotate(-90deg);
}
</style>
